export interface PartnerCustomer {
  id: number;
  noomId: number;
  name: string;
  registryNumber: string;
}

export enum PartnerCredentialStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  REVOKED = 'REVOKED',
  EXPIRED = 'EXPIRED'
}

export interface PartnerCredential {
  id: number;
  name?: string;
  expiresAt?: string;
  lastUsedAt?: string;
  status: PartnerCredentialStatus;
}
export interface Partner {
  id: number;
  name: string;
  contactEmail?: string;
  cardNumberMaskLength: number;
  isActive: boolean;
  clientId: string;
  hourlyRequestLimit: number;
  dailyRequestLimit: number;
  canReadDocuments: boolean;
  canReadCreditInfo: boolean;
  canReportCardPickup?: boolean;
  dateCreated: string;
  customers?: PartnerCustomer[];
  credentials?: PartnerCredential[];
}

export interface PartnerForm {
  name?: string;
  contactEmail?: string;
  cardNumberMaskLength?: number;
  isActive: boolean;
  hourlyRequestLimit?: number;
  dailyRequestLimit?: number;
  canReadDocuments: boolean;
  canReadCreditInfo: boolean;
  canReportCardPickup: boolean;
  customerIds: number[];
}

export interface PartnerCredentialForm {
  name?: string;
  expiresAt?: string;
}

export interface CreatedPartnerCredential extends PartnerCredential {
  partnerId: number;
  secret: string;
}

export enum PartnerSortFields {
  ID = "ID",
  NAME = "NAME"
}

export interface PartnerFilters {
  search?: string;
}
